import { get } from 'lodash';
import { mapGetters, mapState } from 'vuex';

export default {
  props: {
    chartOptions: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop']),
    ...mapState('market', ['chartTimeline', 'chartType', 'market']),
    showDownload() {
      return get(this.chartOptions, 'includeDownload', true);
    },
  },
  methods: {
    onDownload() {
      const url = `${process.env.CHART_CSV_DOWNLOAD_URL}?marketid=${this.market.marketId}&timespan=${this.chartTimeline}`;
      window.open(url, '_blank');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-detail-charts/header/header.js